<template>
<div v-show="isModalVisible">
<div class="modal-mask" @click="closeModal">
      <div class="modal-container" @click.stop>
      <!-- Modal Header -->
      <div class="modal-header">
        <h6 class="modal-title">Preview</h6>
        <button type="button" class="close" data-dismiss="modal" @click="closeModal">&times;</button>
      </div>
      <!-- Modal body -->
      <div class="modal-body">
        <div v-if="src != ''">
          <iframe  :src="src" width="100%" height="780px" id="pdf-frame" ></iframe>
        </div>
        

     </div>
     </div>

</div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import { store } from '../../store/store';
import router from '../../router/index.js';

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});

export default {
  props: [
    'isModalVisible',
    'accountId',
    ],
  data() {
    return {
        loading: false,
        mentee_submit_comment_selected: false,
        menteeId: '',
        submit_comment_checked: 0,
        index: '',
        logoName: '',
        buttonColorCode: '',
        subDomain: '',
        apiUrl: '',
        src: '',
            userAccounts: {
                isUserLinkedMultipleLocations: false,
                locations: [],
                current: {},
            },
            locationsCount: 0,
            researcher: false,
            masterAdmin: false,
            csr: false,

    }
  },
  methods: {
    closeModal() {
      this.$validator.errors.clear();
      this.$emit('close');
    },
            getBrandingPreviewDetail: function(user_id) {
              axios.get('/admin_switch_user/' + user_id, {
              })
              .then(response => {
                let switch_admin_username = response.data.admin_username;
                let switch_admin_firstname = response.data.admin_firstname;
                let switch_admin_roles = response.data.admin_roles;
                let switch_admin_account_flag = response.data.admin_account_flag;
                this.$store.dispatch('switch_admin_user', { switch_admin_username, switch_admin_firstname, switch_admin_roles, switch_admin_account_flag });
                this.locations = response.data.locations_results;
                this.locationsCount = this.locations.length;
                this.userAccounts.isUserLinkedMultipleLocations = false;
                this.userAccounts.locations = this.locations;
                Vue.prototype.$logoName = '';
                if (this.locationsCount > 1) {
                    this.userAccounts.isUserLinkedMultipleLocations = true;
                    this.$store.dispatch('set_user_locations', this.userAccounts);
                    this.src = process.env.VUE_SITE_URL + 'user/select-location';
                } else {
                    this.$store.dispatch('set_user_accountid', this.userAccounts.locations[0].accId);
                    this.$store.dispatch('set_user_locations', this.userAccounts);
                    if(response.data.admin_account_flag == 1) {
                      this.src = process.env.VUE_SITE_URL + 'school-admin-dashboard';
                    }
                    else {
                      this.src = process.env.VUE_SITE_URL + 'company-admin-dashboard';
                    }
                }
              })
              .catch(error => {

              });
            },
    

    navigate(){
        this.$router.push(this.$router.currentRoute.fullPath)
        this.$router.go();
    }
  },
  created() {
    this.apiUrl = process.env.API_ENDPOINT;
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  margin: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  transition: opacity .3s ease;
  overflow-y: scroll;
}
.modal-container {
  position: relative;
  left: 0;
  top: 0;
  width: 99%;
  height: 98%;
  overflow-y: auto;
  padding: 20px 30px;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, .33);
  transition: all .3s ease;
}
.modal-body {
  margin: 0px;
  padding: 10px;
}
.modal-header .sub-heading {
  background-color: #FFF;
  color: #555;
}
.modal-header {
  padding: 5px;
}
.modal-header .close {
  margin: -1.5rem -2rem -1rem auto;
}
.history-table-wrapper {
  height: 350px;
  overflow-y: auto;
}
.modal-footer {
  border-top: none;
}
.btn-danger {
  background-color: #00ACEE;
  border-color: #00ACEE;
}
.modal-title {
  color: #7d7d7d;
  font-size: 14px;
  font-weight: 900;
}
.modal-header {
  border-bottom: 0px;
  margin-bottom: 10px;
}
.modal-body {
  padding: 5px;
}
.ma-blue-btn, .ma-blue-btn:hover, .ma-blue-btn:focus  {
  color: #FFF !important; 
  background-color: #00acee !important;
  border: 1px solid #00acee !important;
  border-radius: 0 !important;
  font-weight: 900;
  padding: 5px 25px;
}
.form-control { font-size: 14px; }
.hide_vmessage {
  display: none !important;
}
.show_vmessage {
  display: block !important;
}
@media (min-width: 320px) and (max-width: 991px) { 
  .modal-container {
    width: 100%;
  }
}
.ma-reset-password-btn, .ma-reset-password-btn:focus, .ma-reset-password-btn:active, .ma-reset-password-btn:hover {
  color: #FFF !important;
  background: #00ACEE !important;
  border: 1px solid #00ACEE !important;
  min-height: 35px;
  margin-top: -5px;
}
</style>


// WEBPACK FOOTER //
// src/components/admin/account_lookup_branding_setting_preview.vue